/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ShellInitializer as GlobalInitializer } from '@teamworks/global';

export class ShellInitializer {

  static initialize() {
    GlobalInitializer.initialize();
  }

}
